import "./EmbeddedPage.css"
import "./GalleryLinkPage.css"

const GALLERY_URL = "https://yardtofork.com/portfolio"

export default function GalleryLinkPage() {
  return (
    <div className="info-iframe-container info-gallery-link-page">
      <a
        className="info-gallery-link-btn"
        href={GALLERY_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        Open Gallery
      </a>
      <p className="info-gallery-link-note">Opens in a new tab.</p>
    </div>
  )
}
